var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { FormControl, FormGroup, FormHelperText, FormLabel } from "@mui/material";
// styles
import "./checkboxGroup.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-checkboxGroup",
    orientation: "vertical",
};
const CheckboxGroup = (_a) => {
    var { label, helpText, orientation, className, children } = _a, rest = __rest(_a, ["label", "helpText", "orientation", "className", "children"]);
    const classList = classNames("tecma-checkboxGroup", orientation, className);
    return (_jsxs(FormControl, Object.assign({ className: classList, component: "fieldset", variant: "standard" }, rest, { children: [_jsx(FormLabel, { component: "legend", focused: false, children: label }), _jsx(FormGroup, { children: children }), _jsx(FormHelperText, { children: helpText })] })));
};
CheckboxGroup.defaultProps = defaultProps;
export default React.memo(CheckboxGroup);
